var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-box"},[_c('div',{staticClass:"block-item"},[_c('div',{staticClass:"label"},[_vm._v("\n            "+_vm._s(_vm.configData.title)+"\n        ")]),_c('el-cascader',{attrs:{"options":_vm.treeSelect,"props":{
            checkStrictly: true,
            emitPath: false,
            label: 'name',
            value: 'category_id'
        },"clearable":""},model:{value:(_vm.configData.activeValue),callback:function ($$v) {_vm.$set(_vm.configData, "activeValue", $$v)},expression:"configData.activeValue"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }